import {
	AttendanceArraysMutationResult,
	AttendanceMutationRow,
	removeAttendanceMember,
} from './attendance-mutations';
import {
	PromotionResultAttendanceRow,
	WaitListPromotableRow,
	promoteWaitListIntoAttendance,
} from './wait-list-promotion';

/**
 * Atomic remove path for `enrollInScheduleAtomic` mode `remove`: drop the member, then
 * FIFO-promote wait-list rows while attendance is below `reserveLimit`.
 */
export function removeAttendanceWithWaitListPromotion<
	TAtt extends AttendanceMutationRow,
	TWait extends WaitListPromotableRow,
>(
	scheduleId: string,
	attendance: readonly TAtt[],
	waitList: readonly TWait[],
	memberId: string,
	reserveLimit: number,
): AttendanceArraysMutationResult<TAtt | PromotionResultAttendanceRow, TWait> {
	const removed = removeAttendanceMember(attendance, memberId);
	if (!removed.changed) {
		return { attendance: [...attendance], waitList: [...waitList], changed: false };
	}

	const promoted = promoteWaitListIntoAttendance(scheduleId, removed.attendance, waitList, reserveLimit);

	return {
		attendance: promoted.attendance,
		waitList: promoted.waitList,
		changed: true,
	};
}
